import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { MESSAGES, SUPPORTED_LOCALES } from './messages';

const interpolate = (template, vars) => {
  if (!vars || typeof template !== 'string') return template;
  return template.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? String(vars[k]) : `{${k}}`));
};

export function translate(locale, key, varsOrFallback, maybeFallback) {
  const loc = SUPPORTED_LOCALES.includes(locale) ? locale : 'zh';
  let vars;
  let fallback;
  if (varsOrFallback && typeof varsOrFallback === 'object' && !Array.isArray(varsOrFallback)) {
    vars = varsOrFallback;
    fallback = maybeFallback;
  } else {
    fallback = varsOrFallback;
  }
  const raw = MESSAGES[loc]?.[key] ?? MESSAGES.zh?.[key] ?? fallback ?? key;
  return interpolate(raw, vars);
}

export function useI18n() {
  const locale = useSelector((state) => state.customization.locale) || 'zh';

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = locale === 'zh' ? 'zh-CN' : locale;
    }
  }, [locale]);

  const t = useCallback((key, varsOrFallback, maybeFallback) => translate(locale, key, varsOrFallback, maybeFallback), [locale]);

  return { t, locale };
}

export { MESSAGES, SUPPORTED_LOCALES };
